<template>
  <div>
    <!-------- start toast / snackbar------------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!-------- end toast / snackbar------------------->
    <v-row>
      <v-col cols="12" md="6">
        <div>
          <h1>Add New Article</h1>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <!-- <div class="d-flex justify-end">
          <div>
            <v-btn icon id="no-background-hover" to="/blog" class="">
              <span class="group pa-2">
                <v-icon medium>mdi-keyboard-backspace</v-icon>
              </span>
            </v-btn>
            
          </div>
        </div> -->
      </v-col>
    </v-row>
    <div class="my-9">
      <v-tabs v-model="tab" slider-color="transparent">
        <div
          class="d-flex"
          style="width: 100%; background: rgba(236, 241, 242, 1)"
        >
          <v-tab
            ripple
            href="#tab-1"
            @click="
              () => {
                this.tab == 'tab-1';
                this.continuebtn = true;
              }
              "
              ><span class="tabs_style text_style"> Content </span></v-tab
              >
          <v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-2"
            @click="
              () => {
                this.tab == 'tab-2';
                this.continuebtn = true;
              }
              "
              >
            <span class="tabs_style text_style"> Settings </span> </v-tab
          ><v-icon class="mr-5">mdi-chevron-right</v-icon>
          <v-tab
            ripple
            href="#tab-3"
            @click="
              () => {
                this.tab == 'tab-3';
                this.continuebtn = false;
              }
              "
              >
            <span class="tabs_style text_style"> Preview/Publish </span>
          </v-tab>
        </div>
        <v-tab-item value="tab-1">
          <v-card-text>
            <div style="margin: 0 8.9vw">
              <div>
                <v-text-field
                  hide-details
                  flat
                  style="font-size: 1.4rem; max-height: 100% !important"
                  class=""
                  v-model="$v.form.Title.$model"
                  label="Write you title here"
                ></v-text-field>
              </div>
              <div class="red--text" v-if="$v.form.Title.$error">
                Title is required
              </div>
              <div>
                <v-textarea
                  name="input-7-1"
                  label="Description"
                  v-model="$v.form.Description.$model"
                ></v-textarea>
              </div>
              <div class="red--text mb-9" v-if="$v.form.Description.$error">
                Description is required
              </div>
              <div class=" mt-4">
                <v-text-field
                  class="pt-1"
                  single-line
                  dense
                  outlined
                  placeholder="Submitted by"
                  v-model="$v.form.SubmittedBy.$model"
                ></v-text-field>
                <!-- <v-select
                  item-text="FirstName"
                  item-value="Id"
                  class="pt-1"
                  :items="GetSiteUser"
                  label="Submitted by (type User name to search)"
                  single-line
                  dense
                  outlined
                  hide-details=""
                  v-model="$v.form.SubmittedBy.$model"
                ></v-select> -->
              </div>
              <div class="red--text mb-9" v-if="$v.form.SubmittedBy.$error">
                User is required
              </div>
              <div>
                <blogimageuploader-component @SetBanner="SetBanner" />
              </div>
              <div class="red--text my-5" v-if="$v.form.Banner.$error">
                Banner is required
              </div>
              <div class="my-6">
                <vue-editor
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                  @image-removed="handleImageRemove"
                  v-model="form.Content"
                  ref="contentBlog"
                ></vue-editor>
                <div class="red--text my-5" v-if="$v.form.Content.$error">
                  Description is required
                </div>
                <!-- <blogtextediter-component @SetContent="SetContent" /> -->
              </div>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card-text>
            <div>
              <v-card
                class="my-2"
                flat
                style="
                  background-color: rgba(222, 227, 239, 1);
                  padding: 2.5rem 1.5rem;
                "
              >
                <span class="h1_tab2"
                  >Related posts {{ GetSelectedRelatedBlogs.length }}/3
                </span>
                <span style="display: block"
                  >Connect related content from your News to give readers more
                  to explore.
                </span>
                <v-row
                  style="
                    margin: auto;
                    justify-content: center;
                    padding: 0.5rem 0;
                  "
                >
                  <v-col
                    cols="12"
                    md="4"
                    v-for="(item, index) in GetSelectedRelatedBlogs"
                    :key="index"
                    class="related-col"
                  >
                    <v-card
                      class="my-4"
                      outlined
                      style="border: 1px solid rgba(8, 8, 22, 0.15)"
                      flat
                      v-if="item.Visibility"
                    >
                      <v-img
                        :src="item.Banner"
                        cover
                        class="related-img"
                      ></v-img>
                      <div class="pa-4">
                        <span class="content_span">{{ item.Title }}</span>
                        <div>
                          <span class="content_date">{{
                            item.ModifiedDate == null
                              ? new Date().toISOString().split("T")[0]
                              : item.ModifiedDate.split("T")[0]
                          }}</span>
                        </div>
                        <div v-if="item.Visibility" class="mt-3">
                          <v-chip color="#E2F2E6" class="px-6">
                            <span class="content_chip">
                              {{ item.Visibility ? "Published" : "" }}
                            </span></v-chip
                          >
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
                <div class="mt-2">
                  <v-btn
                    @click="Rcontentdialog = true"
                    class="px-6 text_style"
                    outlined
                    style="
                      border: 1px solid rgba(8, 8, 22, 0.15);
                      color: rgba(34, 34, 34, 0.7);
                    "
                    >Add related content</v-btn
                  >
                </div>
                <v-dialog v-model="Rcontentdialog" max-width="900">
                  <!-- <template v-slot:activator="{ on, attrs }"> -->
                  <!-- <div class="mt-2">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="px-6 text_style"
                        outlined
                        style="
                          border: 1px solid rgba(8, 8, 22, 0.15);
                          color: rgba(34, 34, 34, 0.7);
                        "
                        >Add related content</v-btn
                      >
                    </div> -->
                  <!-- </template> -->
                  <v-card v-if="Rcontentdialog">
                    <blogrelatedcontent-componet />
                    <v-card-actions class="px-9">
                      <v-spacer></v-spacer>
                      <v-btn
                        color="#A1A3A8"
                        class="text_style mx-3"
                        text
                        @click="
                          Rcontentdialog = false;
                          fetchData();
                        "
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="primary"
                        depressed
                        class="px-14 text_style"
                        :disabled="btnloader"
                        @click="RelatedContentSend()"
                      >
                        <span v-if="btnloader != true">Save</span>
                        <v-progress-circular
                          indeterminate
                          v-else
                          size="20"
                          class="px-5"
                          color="white"
                          v-show="btnloader"
                        ></v-progress-circular>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
              <!-- <v-card
                class="my-6 pa-9"
                flat
                style="background-color: rgba(222, 227, 239, 1)"
              >
                <span class="h1_tab2">Language </span>
                <span style="display: block">Select interface language </span>
                <v-card class="mt-6" flat>
                  <v-select
                    class="pt-1"
                    :items="language"
                    label="Language"
                    dense
                    single-line
                    outlined
                    hide-details=""
                    v-model="form.Language"
                  ></v-select>
                </v-card>
              </v-card> -->
              <v-card
                class="my-6 pa-9"
                flat
                style="background-color: rgba(222, 227, 239, 1)"
              >
                <span class="h1_tab2">Visibility </span>
                <span style="display: block"
                  >Choose whether to publicly display this artical or hide it
                </span>
                <v-card class="mt-6" flat>
                  <v-select
                    class="pt-1"
                    :items="visible"
                    label="Visible (default)"
                    dense
                    single-line
                    outlined
                    hide-details=""
                    v-model="form.Visibility"
                  ></v-select>
                </v-card>
              </v-card>
            </div>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="tab-3">
          <ArticalSectionComponent :Data="form"></ArticalSectionComponent>
        </v-tab-item>
      </v-tabs>
    </div>
    <v-divider class="my-6"></v-divider>
    <v-card flat class="d-flex justify-end mb-9">
       <v-btn
      outlined
      style="border: thin solid rgba(8, 8, 22, 0.15)"
      class="px-9 py-2 mx-9 text_style"
      color="primary"
      :disabled="saveloader"
      @click="send('Draft')"
    >
      <span v-if="!saveloader">Save Draft</span>
      <v-progress-circular
        v-else
        indeterminate
        size="20"
        class="px-5"
        color="#1976d2"
      ></v-progress-circular>
    </v-btn>
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        @click="changeTab()"
        v-if="continuebtn == true"
        >Continue</v-btn
      >
      <v-btn
        color="primary"
        class="px-9 py-2 text_style"
        v-if="continuebtn == false"
        :disabled="btnloader"
        @click="send('Published')"
      >
        <span v-if="btnloader != true"> Publish now </span>
        <v-progress-circular
          indeterminate
          size="20"
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { VueEditor } from "vue2-editor";
import BlogimageuploaderComponent from "./blogimageuploader.component.vue";
// import BlogtextediterComponent from "./blogtextediter.component.vue";
import BlogrelatedcontentComponet from "./blogrelatedcontent.componet.vue";
import ArticalSectionComponent from "./articalsection.component.vue";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import SuccessToastComponent from "../Toast/SuccessToast.component.vue";
import ErrorToastComponent from "../Toast/ErrorToast.component.vue";

export default {
  components: {
    BlogimageuploaderComponent,
    SuccessToastComponent,
    // BlogtextediterComponent,
    ErrorToastComponent,
    BlogrelatedcontentComponet,
    ArticalSectionComponent,
    VueEditor,
  },

  name: "NewArticalComponent",
  computed: {
    ...mapGetters([
      "GetLoggedInUser",
      "GetSiteUser",
      "GetSelectedRelatedBlogs",
      "GetBlogs",
    ]),
  },
  mounted() {
    this.fetchData();
    this.form.CreatedDate = new Date().toISOString();
  },

  data() {
    return {
      items: "",
      btnloader: false,
      saveloader: false,
      Rcontentdialog: false,
      continuebtn: true,
      tab: "tab-1",
      chipsvalue: null,
      chips: [],
      loading: false,
      selection: 1,
      snackbar: false,
      SuccessToast: false,
      ErrorToast: false,
      language: ["English", "Spanish", "Turkish", "German"],
      visible: ["Hide", "Show"],
      form: {
        Title: "",
        Description: "",
        Banner: "",
        Content: "", // With full bucket URLs (for editor display)
        OriginalContent: "", // With only image paths (for API)
        Language: "English",
        SubmittedBy: "",
        Visibility: "Show",
        SubmittedByName: "",
        SubmittedByProfileImage: "",
        CreatedDate: "",
        RelatedBlogs: [],
      },
    };
  },
  validations: {
    form: {
      Title: {
        required,
      },
      Description: {
        required,
      },
      Banner: {
        required,
      },
      SubmittedBy: {
        required,
      },
      Content: {
        required,
      },
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) { 

      let originalName = file.name;
      // Extract file extension
      const extension = originalName.substring(originalName.lastIndexOf('.') + 1);
      const baseName = originalName.substring(0, originalName.lastIndexOf('.'));

      // Replace all invalid characters with underscore
      const safeBaseName = baseName.replace(/[^a-zA-Z0-9_-]/g, '_');
      // Rebuild sanitized file name
      const safeFileName = `${safeBaseName}.${extension}`;
      // Create a new File object with the sanitized name
      const sanitizedFile = new File([file], safeFileName, { type: file.type });
      this.$store.dispatch("UploadImage", sanitizedFile).then((bucketUrl) => {
        Editor.insertEmbed(cursorLocation, "image", bucketUrl);
        resetUploader();
      });
    },
    handleImageRemove(file) {
      this.$store.dispatch("DeleteImage", file);
    },

    extractImagePath(bucketUrl) {
      try {
        const url = new URL(bucketUrl);
        let path = url.pathname;
        
        if (path.startsWith('/')) {
          path = path.substring(1);
        }
        
        return path;
      } catch (error) {
        console.error('Error parsing URL:', error);
        if (bucketUrl.startsWith('/')) {
          return bucketUrl.substring(1);
        }
        return bucketUrl;
      }
    },

    // Convert bucket URLs to simple image paths for API
    convertContentForAPI(content) {
      if (!content) return content;
      
      let convertedContent = content;
      
      // Find all image tags and replace bucket URLs with just image paths
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      
      convertedContent = convertedContent.replace(imgRegex, (match, srcUrl) => {
        const imagePath = this.extractImagePath(srcUrl);
        
        // Replace the src attribute with just the image path
        return match.replace(`src="${srcUrl}"`, `src="${imagePath}"`);
      });
      
      return convertedContent;
    },

    fetchData() {
      this.$store.dispatch("getSiteUser");
      var obj = {
        page: 1,
        pageSize: 100,
        search: "",
        filters: "",
      };
      this.$store.dispatch("GetBlogs", obj);
    },
    RelatedContentSend() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.Rcontentdialog = false;
        this.btnloader = false;
      }, 2000);
      this.fetchData();
    },
    send(Type) {
      this.checkvalidations();
      // replace bucket URLs with simple image paths
      const ContentWithoutBucketPaths = this.convertContentForAPI(this.form.Content);
      
      var Form = new FormData();
      this.GetSelectedRelatedBlogs.forEach((x) => {
        Form.append("RelatedBlogs", x.Id);
      });
      Form.append("Title", this.form.Title);
      Form.append("Description", this.form.Description);
      Form.append("SubmittedBy", this.form.SubmittedBy);
      Form.append("Banner", this.form.Banner);
      Form.append("Content", ContentWithoutBucketPaths);
      Form.append("Status", Type);
      Form.append("Language", this.form.Language);
      Form.append("Visibility", this.form.Visibility == "Hide" ? false : true);
      if (Type === "Published") {
        if (
          this.$v.form.Title.$invalid ||
          this.$v.form.Description.$invalid ||
          this.$v.form.Banner.$invalid ||
          this.$v.form.SubmittedBy.$invalid ||
          this.$v.form.Content.$invalid
        ) {
          Swal.fire({
              position: "center",
              icon: "error",
              title: "Please fill all required fields",
              timer: 3500,
            });
        } else {
         this.btnloader = true;
          this.$store.dispatch("PublishBlog", Form).then((res) => {
            if(res.Status){
              this.btnloader = false;
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Created Successfully",
                showConfirmButton: false,
                timer: 3500,
              });
              this.$router.push("/blog");
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 3500,
                toast:true,
              });
              this.btnloader = false;
            }
          });
        }
      } else if (Type === "Draft") {
         this.saveloader = true;
        if (
          this.$v.form.Title.$invalid ||
          this.$v.form.Description.$invalid ||
          this.$v.form.Banner.$invalid ||
          this.$v.form.SubmittedBy.$invalid ||
          this.$v.form.Content.$invalid
        ) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Please fill all required fields",
            timer: 3500,
          });
          this.saveloader = false;
        } else {
          this.$store.dispatch("PublishBlog", Form).then((res)=>{
            if(res.Status){
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Draft Saved Successfully",
                showConfirmButton: false,
                timer: 3500,
              });
              this.$router.push("/blog");
              this.saveloader = false;
            } else {
              this.saveloader = false;
              Swal.fire({
                position: "center",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 3500,
              });
            }
            }).finally(() => {
            this.saveloader = false;
          });
        }
      }
    },
    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [...this.chips];
    },
    changeTab() {
      if (this.tab == "tab-1") {
        this.checkvalidations();
        let submittedUser = this.GetSiteUser.find(
          (x) => x.Id === this.form.SubmittedBy
        );
        if (submittedUser != undefined) {
          this.form.SubmittedByName = submittedUser.FirstName;
          this.form.SubmittedByProfileImage = submittedUser.ProfileImage;
        }
        this.$v.$touch();
        if (
          this.$v.form.Title.$invalid ||
          this.$v.form.Description.$invalid ||
          this.$v.form.Banner.$invalid ||
          this.$v.form.SubmittedBy.$invalid ||
          this.$v.form.Content.$invalid
        ) {
          this.submitStatus = "ERROR";
        } else {
          this.tab = "tab-2";
        }
      } else {
        this.tab = "tab-3";
        this.continuebtn = false;
      }
    },
    SetContent(content) {
      this.form.Content = content;
    },
    SetBanner(banner) {
      this.form.Banner = banner;
    },
    checkvalidations(){
        this.$v.form.Title.$touch();
        this.$v.form.Description.$touch();
        this.$v.form.Banner.$touch();
        this.$v.form.SubmittedBy.$touch();
        this.$v.form.Content.$touch();
    },
  },
};
</script>

<style scoped>
.v-input__slot {
  padding: 0px !important;
}

h1 {
  font-family: "Noto Serif";
  font-size: 40px;
  font-weight: 700;
  line-height: 54px;
  letter-spacing: 0em;
  text-align: left;
  color: #222222;
}

.tabs_style {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
}

a:hover {
  text-decoration: none;
}

.v-tabs-slider {
  background-color: white !important;
}

.h1_tab2 {
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}

.content_span {
  font-family: " DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}

.content_date {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.38);
}

.content_chip {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #54be5a;
}

#no-background-hover::before {
  background-color: transparent !important;
}

@media screen and (max-width: 750px) {
  h1 {
    font-size: 23px;
  }
}

@media screen and (max-width: 430px) {
  .v-application .mx-14 {
    margin-right: 20px !important;
    margin-left: 10px !important;
  }
}
@media (min-width: 425px) {
  .related-img {
    max-height: 130px;
    min-height: 130px;
  }
}
@media (min-width: 768px) {
  .related-col {
    max-width: 320px;
    margin: auto;
  }
  .related-img {
    max-height: 150px;
    min-height: 150px;
  }
}
@media (min-width: 1024px) {
  .related-col {
    max-width: 260px;
    margin: 0;
  }
  .related-img {
    max-height: 100px;
    min-height: 100px;
  }
}
.related-img {
  height: 100px;
  height: 100px;
  min-width: 100%;
  max-width: 100%;
}
</style>
